import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { CONTRACTED_SERVICE, contratedServiceEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(CONTRACTED_SERVICE);

const ContractedService = ({ isOpen, onClick, onApply, contractedService }) => {
  const [selectedItem, setSelectedItem] = useState(contractedService);

  useEffect(() => {
    if(contractedService?.length < 1) {
      setSelectedItem([]);
    }
  }, [contractedService]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter label="Serviço Contratado" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por serviço contratado"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={contratedServiceEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  contractedService: state.tracking.filters.listContractedService,
});

export default connect(mapStateToProps)(ContractedService);
